// extracted by mini-css-extract-plugin
module.exports = {"label":"EngineCompartmentApiKeyPage_label__3T3ra","disableTextColor":"EngineCompartmentApiKeyPage_disableTextColor__2qza1"};